import React from 'react'
import Headers from '../headers/Headers'
import Footers from '../footers/Footers'
import FooterCall from '../footers/FooterCall'

const Gallery = () => {
  return (
    <>
    <Headers/>
     <h1>Gallery</h1>
     <Footers/>
     <FooterCall/> 
    </>
  )
}

export default Gallery
